import { render, staticRenderFns } from "./BizInsuranceDataImportModal.vue?vue&type=template&id=1ec38c96&"
import script from "./BizInsuranceDataImportModal.vue?vue&type=script&lang=js&"
export * from "./BizInsuranceDataImportModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports